<template>
  <div class="d-flex justify-content-between my-5">
    <div class="d-flex gap-3 w-100 item">

      <div class="user-avatar d-md-block">
        <img loading="lazy" :src="getProfilePictureUrl" alt="" width="80" height="80"
          class="rounded-circle img-fluid shadow-sm">
      </div>

      <div class="hidden-email-large">
        <a :href="'mailto:' + item.email" class="fw-light mb-2 text-nowrap" v-if="showEmail">
          <i class="fa fa-envelope" aria-hidden="true"></i> {{ item.email }}
        </a>
      </div>

      <div class="d-flex flex-column text-section w-100">
        <h2 :class="{ 'text-danger': fullName === null }" class="mb-0 h4 item-width">{{ fullName }}</h2>

        <p class="medias my-0 item-width">
          {{ getMedias }}
        </p>

        <p class="mt-0 text-muted item-width" v-if="this.item.journalist_group.function">
          {{ this.item.journalist_group.function }}
        </p>

        <p class="subjects font-weight-light item-width">
          {{ getSubjects }}
        </p>
      </div>
    </div>

    <div class="right-sidebar">
      <a :href="'mailto:' + item.email" class="fw-light mb-2 text-nowrap" v-if="showEmail">
        <i class="fa fa-envelope" aria-hidden="true"></i> {{ item.email }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DirectorySingleJournalist',
  props: {
    item: Object
  },

  computed: {
    showEmail() {
      return !this.item.journalist_group.show_pro_address;
    },

    fullName() {
      return (this.item.first_name + ' ' + this.item.last_name).trim();
    },

    getProfilePictureUrl() {
      return this.item.journalist_group.picture.url ?? this.item.avatar_url;
    },

    getSubjects() {
      return this.item.journalist_group.subjects.join(' - ')
    },

    getMedias() {
      if (Array.isArray(this.item.journalist_group.medias)) {
        return this.item.journalist_group.medias.map((media) => media.post_title).join(', ').trim();
      }

      return 'Non spécifié';
    }
  }
}
</script>

<style scoped>
.medias {
  text-transform: uppercase;
  color: #F05A28;
}

.user-avatar img {
  width: 80px;
  height: 80px;
  min-width: 80px;
  min-height: 80px;
  object-fit: cover;
}

h2.h4 {
  text-transform: capitalize;
}

.item-width {
  width: 75%;
}

@media (min-width: 768px) {
  .hidden-email-large {
    display: none;
  }
}

@media (max-width: 767px) {
  .right-sidebar {
    display: none;
  }

  .item {
    flex-direction: column;
  }

  .item-width {
    width: 100%;
  }
}
</style>
